import * as moment from 'moment';
import jwt_decode from "jwt-decode";
import CryptoJS from "crypto-js";
import { hasAccess } from "./Permission";

export function SetToken(token) {
    window.localStorage.setItem("lpl_abha:token", token || "")
}
export function SetAcessToken(token) {
    window.localStorage.setItem("lpl_abha:AccessToken", token || "")
}

export function GetToken() {
    let token = window.localStorage.getItem("lpl_abha:token") || ""
    return token
}
export function GetAcessToken() {
    let token = window.localStorage.getItem("lpl_abha:AccessToken") || ""
    return token
}

export function DeleteToken() {
    window.localStorage.removeItem("lpl_abha:token")
}
export function GetLoggedInUser() {
    let token = GetToken();
    if (token) {
        const user = jwt_decode(token);
        // The token stores the user id as `id`; pages read UserId
        return { ...user, UserId: user?.UserId ?? user?.id }
    } else {
        return {}
    }
}

let LODDED_USER = GetLoggedInUser();
export const UserId = (LODDED_USER?.UserId)
export const RoleId = (LODDED_USER?.role_id)
// console.log (RoleId);


// Super admin flag comes from the login token (backend re-checks on every request)
export function isSuperAdmin() {
    let LODDED_USER = GetLoggedInUser();
    return LODDED_USER?.is_super_admin === true;
}

export function GetLoggedInOrganization() {
    let LODDED_USER = GetLoggedInUser();
    return {
        OrganizationId: LODDED_USER?.organization_id || "",
        Name: LODDED_USER?.organization_name || "",
    };
}

// Roles a user of this organization can get: shared roles plus the organization's own
export function rolesForOrganization(roleList, organizationId) {
    if (!Array.isArray(roleList)) return [];
    return roleList.filter((role) => role.IsShared || role.OrganizationId === organizationId);
}

export function DateFormat(date) {
    return (date && moment(date).format("MMM DD YYYY")) || "";
}
export function DateFormatWithTime(date) {
    return (date && moment(date).format("DD-MM-YYYY H:mm:ss")) || "";
}
export function getDatesInRange(first, second) {
    const date = new Date(first?.getTime());
    const dates = [];
    while (date <= second) {
        dates.push(moment(date).format("YYYY-MM-DD"));
        date.setDate(date.getDate() + 1);
    }
    return dates
}
export function DayFrom(date) {
    if (date) {
        const firstDate = new Date(date);
        var diffDays = moment().diff(firstDate, 'days');
        return diffDays
    } else {
        return ""
    }
}
export function FromNow(date) {
    return (date && moment(date).fromNow()) || "";
}
export function onlyMobileInput() {
    let mobile = document.getElementById("only_mobile");
    let mobile1 = document.getElementById("only_mobile1");
    let mobile2 = document.getElementById("only_mobile2");
    let mobile3 = document.getElementById("only_mobile3");
    if (mobile) {
        mobile.addEventListener("input", function () {
            if (/\D/g.test(this.value)) {
                this.value = this.value.replace(/\D/g, "");
            }
        })
    }
    if (mobile1) {
        mobile1.addEventListener("input", function () {
            if (/\D/g.test(this.value)) {
                this.value = this.value.replace(/\D/g, "");
            }
        })
    }
    if (mobile2) {
        mobile2.addEventListener("input", function () {
            if (/\D/g.test(this.value)) {
                this.value = this.value.replace(/\D/g, "");
            }
        })
    }
    if (mobile3) {
        mobile3.addEventListener("input", function () {
            if (/\D/g.test(this.value)) {
                this.value = this.value.replace(/\D/g, "");
            }
        })
    }
}

export function isNegative(num) {
    if (Math.sign(num) === -1) {
        return true;
    }
    return false;
}
export function getCurrentYear() {
    let currentYear = moment(new Date()).format("YYYY");
    return currentYear;
}
export function getDaysByMonth() {
    var daysArr = [];
    var monthDate = moment().startOf('month');
    for (let i = 0; i < monthDate.daysInMonth(); i++) {
        let newDay = monthDate.clone().add(i, 'days');
        daysArr.push({ date: newDay.format('D'), month: newDay.format('MMM'), value: newDay.format('DD') });
    }
    return daysArr
};
// Sidebar: '' shows the item, 'none' hides it. `access` is the role's
// permissions from the server (state.common.access); see utils/Permission.js
export function ShowMenu(Module, access) {
    return hasAccess(access, Module, 'List') ? '' : 'none';
}
export function encryptedData(text){
    const _encryptedData = text ? CryptoJS.AES.encrypt(text?.toString(), "7f989e7193e65e5cea51876264c47248")?.toString() : "";
    return _encryptedData
} 
export function decryptData(encryptedData)  {
    try {
      var decrypted = CryptoJS.AES.decrypt(encryptedData, "7f989e7193e65e5cea51876264c47248");
      return decrypted.toString(CryptoJS.enc.Utf8);
    } catch (error) {
      console.log(error);
      return false;
    }
  }
export function downloadBase64ToPDF(pdfData) {
    const linkSource = `data:application/pdf;base64,${pdfData}`;
    const downloadLink = document.createElement("a");
    const fileName = `report_${new Date().getTime()}.pdf`;
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
}